import { LINK_PREVIEW_TYPES } from 'dpl/messaging/utils/constants';
import { LEARNING_CENTER_WHY_PAYMENT_GOOD_DOG_PATH } from 'dpl/shared/constants/urls';

export const BREEDER_PAYMENT_STATUSES = {
  PENDING: 'Pending',
  AVAILABLE: 'Available',
  PAYOUT_FAILED: 'Payout Failed',
  SENT_BACK: 'Sent Back',
  REFUNDED: 'Refunded',
  PARTIALLY_REFUNDED: 'Partially refunded',
  REFUND_REQUESTED: 'Refund Requested',
  DECLINED: 'Declined',
  PAID_OUT: 'Paid Out',
  REQUESTED: 'Requested',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
  IN_REVIEW: 'In Review',
  REVIEW_REJECTED: 'Review Rejected',
  COMPLETED: 'Completed',
  MANUALLY_PAID: 'Marked as paid',
  SCHEDULED: 'Scheduled'
};

export const BREEDER_PAYMENT_STATUS_DESCRIPTIONS = {
  [BREEDER_PAYMENT_STATUSES.PENDING]:
    'Buyer-initiated payment has not been accepted or sent back by the breeder.',
  [BREEDER_PAYMENT_STATUSES.AVAILABLE]:
    'Funds available but the payout method has not been set up or requires manual payout.',
  [BREEDER_PAYMENT_STATUSES.PAYOUT_FAILED]:
    'Payout process was started but failed.',
  [BREEDER_PAYMENT_STATUSES.SENT_BACK]:
    'Buyer-initiated payment sent back to buyer.',
  [BREEDER_PAYMENT_STATUSES.REFUNDED]: 'This payment request was refunded.',
  [BREEDER_PAYMENT_STATUSES.SCHEDULED]:
    'This upcoming payment will be charged based on your payment policy',
  [BREEDER_PAYMENT_STATUSES.PARTIALLY_REFUNDED]:
    'This payment request was refunded for only part of the amount.',
  [BREEDER_PAYMENT_STATUSES.REFUND_REQUESTED]:
    'A refund request has been initiated for this payment.',
  [BREEDER_PAYMENT_STATUSES.DECLINED]:
    'This buyer-initiated payment has been declined by the breeder.',
  [BREEDER_PAYMENT_STATUSES.PAID_OUT]:
    'The funds are on their way to the payout method of choice.',
  [BREEDER_PAYMENT_STATUSES.REQUESTED]:
    'This payment has been requested from the buyer that has not been completed yet.',
  [BREEDER_PAYMENT_STATUSES.EXPIRED]:
    'The buyer-initiated payment was not accepted or sent back within 10 days so the payment will be refunded to the buyer.',
  [BREEDER_PAYMENT_STATUSES.CANCELLED]:
    'This payment has been canceled by the requester prior to requestee completing the payment.',
  [BREEDER_PAYMENT_STATUSES.IN_REVIEW]:
    'The charge associated with the payment request has been put into review.',
  [BREEDER_PAYMENT_STATUSES.REVIEW_REJECTED]:
    'The charge associated with the payment request was in review and not approved, so funds are refunded to the buyer.',
  [BREEDER_PAYMENT_STATUSES.COMPLETED]:
    'This payment request has been completed.',
  [BREEDER_PAYMENT_STATUSES.MANUALLY_PAID]:
    'This payment request was marked as paid outside of Good Dog'
};

export const BUYER_PAYMENT_STATUSES = {
  NOT_PAID: 'Not Paid',
  DECLINED: 'Declined',
  PAID: 'Paid',
  PARTIALLY_REFUNDED: 'Partially refunded',
  REFUNDED: 'Refunded',
  SCHEDULED: 'Scheduled',
  WITHDRAWN: 'Withdrawn',
  PAYMENT_FAILED: 'Payment failed'
};

export const BUYER_PAYMENT_STATUS_DESCRIPTIONS = {
  [BUYER_PAYMENT_STATUSES.NOT_PAID]:
    'The payment requested has not been completed yet.',
  [BUYER_PAYMENT_STATUSES.DECLINED]:
    'This buyer-initiated payment has been declined by the breeder.',
  [BUYER_PAYMENT_STATUSES.PAID]: 'The payment requested has been completed.',
  [BUYER_PAYMENT_STATUSES.REFUNDED]: 'This payment request was refunded.',
  [BUYER_PAYMENT_STATUSES.PARTIALLY_REFUNDED]:
    'This payment request was refunded for only part of the amount.',
  [BUYER_PAYMENT_STATUSES.PAYMENT_FAILED]:
    'This payment could not be completed.'
};

export const ALL_PAYMENT_STATUSES = {
  ...BREEDER_PAYMENT_STATUSES,
  ...BUYER_PAYMENT_STATUSES
};

export const ALL_PAYMENT_STATUS_DESCRIPTIONS = {
  ...BREEDER_PAYMENT_STATUS_DESCRIPTIONS,
  ...BUYER_PAYMENT_STATUS_DESCRIPTIONS
};

export const OFFPLATFORM_STATE = {
  DATE_PICKER: 'paid_at',
  PAYMENT_OPTION: 'source'
};

export const OFF_PLATFORM_PAYMENT_WARNING =
  'Off-platform payments are prohibited, put you at risk, and may harm your breeder’s standing.';

export const ON_PLATFORM_PAYMENT_POLICY_PREVIEW_LINK = {
  title: 'How payment works on Good Dog',
  description: "Why payments happen on Good Dog and how you're covered.",
  content_type: LINK_PREVIEW_TYPES.PAYMENT_POLICY,
  url: LEARNING_CENTER_WHY_PAYMENT_GOOD_DOG_PATH
};
